module.exports = __webpack_public_path__ + "img/cryptocurrency-04.64ccd985.svg";